module.exports = __webpack_public_path__ + "static/media/bookcoversmall.e54f39a2.jpg";